<template>
  <div class="container">
    <div class="page">
      <div class="header_nav">
        <div>
          <router-link class="router_link" to="/Home/NB">合作厂商一</router-link>
        </div>
        <div>合作厂商二</div>
      </div>
      <div class="img">
        <img src="../assets/images/mt/1.png">
      </div>
      <div class="section">
        <div>
          <div class="title">简介
            <div></div>
          </div>
          <div class="intro">
            某高新产业有限公司位于新材料产业功能区，占地近60亩，建有标准办公楼及厂房20000余平方米。拥有先进的生产设备，良好的生产环境，完善的研发及检测手段，是西南地区最具规模的专业从事高精密度、高可靠性印制板、印制板组件、电子元器件研发及生产型企业。
          </div>
        </div>
        <div>
          <div class="title">服务理念
            <div></div>
          </div>
          <div class="culture">
            <ul>
              <li>
                <div class="icon">
                  <span>敬</span>
                  <span>业</span>
                </div>
              </li>
              <li>
                <div class="icon">
                  <span>专</span>
                  <span>业</span>
                </div>
              </li>
              <li>
                <div class="icon">
                  <span>诚</span>
                  <span>信</span>
                </div>
              </li>
              <li>
                <div class="icon">
                  <span>服</span>
                  <span>务</span>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div>
          <div class="title">主要产品
            <div></div>
          </div>
          <div class="partner_img">
            <div class="img">
              <img src="../assets/images/mt/2.png">
            </div>
            <div class="img">
              <img src="../assets/images/mt/3.png">
            </div>
            <div class="img">
              <img src="../assets/images/mt/4.png">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  }
}
</script>

<style scoped>
/* 二级导航栏 */
.header_nav>div:nth-child(2) {
  background:rgba(0,0,0,1);
  color: #fff;
}
.header_nav>div:nth-child(1):hover {
  color: #a3a3a3;
  cursor: pointer;
}
/* 图片 */
.img {
  margin-bottom: 36px;
}
/* 简介 */
/* 服务理念 */
.intro,.culture {
  margin-bottom: 56px;
}
</style>